import { find } from '../helpers';

const flip = find('[data-swipe-flip]')
const fade = find('[data-swipe-fade]')
const slide = find('[data-swipe-slide]')
const multiple = find('[data-swipe-multiple]')
const multiview = find('[data-swipe-multiview]')
const product = find('[data-swipe-product]')
const related = find('[data-swipe-related]')

if (flip) {
    import(/* webpackChunkName: "flip" */'./flip')
}

if (fade) {
    import(/* webpackChunkName: "fade" */'./fade')
}

if (slide) {
    import(/* webpackChunkName: "slide" */'./slide')
}

if (multiple) {
    import(/* webpackChunkName: "multiple" */'./slide-multiple')
}

if (multiview) {
    import(/* webpackChunkName: "multiview" */'./multiview');
}

if (product) {
    import(/* webpackChunkName: "product" */'./product-images')
}

if (related) {
    import(/* webpackChunkName: "related" */'./slide-related')
}

